module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/overview/level-1_start-6bf328c5226bf5e0a3bcc8c8ee12412b.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/overview/level-1_start.png
// module id = 2271
// module chunks = 2